<div class="event-card" *ngIf="event" [class.selected]="isSelected" (click)="onCardClick()">
  <!-- Event Image -->
  <div class="event-image">
    <img
      [src]="event?.cover_page || 'https://library.micetribe.com/images/default-banner.jpg'"
      [alt]="event?.name || 'Event'"
      onerror="this.src='https://library.micetribe.com/images/default-banner.jpg'"
    />
    <div class="status-overlay">
      <span class="status-badge" [ngClass]="getStatusDisplay(event).class">
        {{ getStatusDisplay(event).text }}
      </span>
    </div>
  </div>

  <!-- Event Content -->
  <div class="event-content">
    <h3 class="event-name" [title]="event?.name || ''">{{ event?.name || 'Unnamed Event' }}</h3>

    <!-- Event Meta Information -->
    <div class="event-meta">
      <!-- Forms Info - Default and Badge Editor Context -->
      <div class="forms-info" *ngIf="context !== 'group-forms'">
        <svg viewBox="0 0 24 24" class="forms-icon">
          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
        </svg>
        <span>{{ getEventFormsCount(event) }} form{{ getEventFormsCount(event) !== 1 ? 's' : '' }}</span>
      </div>

      <!-- Group Forms Context - Enhanced Info -->
      <div class="group-forms-info" *ngIf="context === 'group-forms'">
        <!-- Existing Group Relationships -->
        <div class="group-relationships" *ngIf="getGroupFormRelationships(event).length > 0">
          <div class="relationships-list">
            <div class="relationship-item" *ngFor="let relationship of getGroupFormRelationships(event); trackBy: trackByRelationshipId" (click)="$event.stopPropagation()">
              <div class="relationship-info" (click)="onEditSpecificRelationshipClick($event, relationship)">
                <svg viewBox="0 0 24 24" class="group-icon">
                  <path
                    d="M16,4C18.21,4 20,5.79 20,8C20,10.21 18.21,12 16,12C13.79,12 12,10.21 12,8C12,5.79 13.79,4 16,4M16,13C18.67,13 24,14.33 24,17V20H8V17C8,14.33 13.33,13 16,13M8,4C10.21,4 12,5.79 12,8C12,10.21 10.21,12 8,12C5.79,12 4,10.21 4 8C4,5.79 5.79,4 8,4M8,13C10.67,13 16,14.33 16,17V20H0V17C0,14.33 5.33,13 8,13Z"
                  />
                </svg>
                <span class="relationship-text">{{ relationship.relationship }}</span>
              </div>
              <button type="button" class="edit-relationship-btn" (click)="onEditSpecificRelationshipClick($event, relationship)" title="Edit relationship">
                <svg viewBox="0 0 24 24" class="edit-icon">
                  <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Available Forms for New Relationships -->
        <div class="available-forms" *ngIf="getValidFormsForGroupCreation(event) > 0">
          <svg viewBox="0 0 24 24" class="forms-icon">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
          <span>{{ getValidFormsForGroupCreation(event) }} available form{{ getValidFormsForGroupCreation(event) !== 1 ? 's' : '' }}</span>
        </div>

        <!-- No Forms Available -->
        <div class="no-forms" *ngIf="getValidFormsForGroupCreation(event) === 0 && !hasExistingGroupRelationships(event)">
          <svg viewBox="0 0 24 24" class="warning-icon">
            <path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
          </svg>
          <span>No forms available</span>
        </div>
      </div>

      <!-- Event Dates -->
      <div class="event-dates" *ngIf="event.public_start_date && event.public_end_date">
        <div class="date-item">
          <svg viewBox="0 0 24 24" class="date-icon">
            <path
              d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M16,1H18V3H16V1M6,1H8V3H6V1M19,19H5V8H19V19M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M9,14V16H7V14H9M13,14V16H11V14H13Z"
            />
          </svg>
          <span>{{ event.public_start_date | date : 'mediumDate' }}</span>
        </div>
        <div class="date-separator">→</div>
        <div class="date-item">
          <svg viewBox="0 0 24 24" class="date-icon">
            <path
              d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M16,1H18V3H16V1M6,1H8V3H6V1M19,19H5V8H19V19M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M9,14V16H7V14H9M13,14V16H11V14H13Z"
            />
          </svg>
          <span>{{ event.public_end_date | date : 'mediumDate' }}</span>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons" *ngIf="context === 'group-forms'">
      <!-- Create New Relationship Button - Only show if space for new relationships -->
      <div class="create-button" *ngIf="canCreateGroupRelationships(event)" (click)="onCreateNewRelationshipClick($event)">
        <svg viewBox="0 0 24 24" class="create-icon">
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
        </svg>
        <span>Create New</span>
      </div>

      <!-- Default Select Button for When No Actions Available -->
      <div class="select-button" *ngIf="!canCreateGroupRelationships(event) && !hasExistingGroupRelationships(event)" (click)="onCreateNewRelationshipClick($event)">
        <svg viewBox="0 0 24 24" class="select-icon">
          <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
        <span>Select Event</span>
      </div>
    </div>

    <!-- Event Tools Hub Actions -->
    <div class="action-buttons event-tools-actions" *ngIf="context === 'event-tools'" (click)="$event.stopPropagation()">
      <button type="button" class="tool-action-btn" (click)="onOpenBadgeClick($event)">Badge</button>
      <button type="button" class="tool-action-btn" (click)="onOpenGroupFormsClick($event)">Group Forms</button>
      <button type="button" class="tool-action-btn" (click)="onOpenSettingsClick($event)">Settings</button>
    </div>

    <!-- Default Select Button for Non-Group-Forms / Non-Event-Tools Context -->
    <div class="select-button" *ngIf="context !== 'group-forms' && context !== 'event-tools'">
      <svg viewBox="0 0 24 24" class="select-icon">
        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
      </svg>
      <span>Select Event</span>
    </div>
  </div>

  <!-- Selection Indicator (for Badge Editor) -->
  <div class="selection-indicator" *ngIf="isSelected">
    <svg viewBox="0 0 24 24" class="check-icon">
      <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
    </svg>
  </div>
</div>
